import React, { useEffect, useState } from "react"
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import Application from "services/applications/Application.service"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const EnvAuditApplicationFilter = props => {
  const [filterValues, setFilterValues] = useState({
    applicant: "",
    title_of_project: "",
    project_province: "",
    rapep_firm: "",
    application_status: "",
    submitted_from: "",
    submitted_to: "",
  })

  const handleSubmit = e => {
    e.preventDefault()
    props.handleSearch(filterValues) // Ensure this makes API call with query params
  }

  const clearFields = () => {
    props.turnOffSearch()
    setFilterValues({
      applicant: "",
      title_of_project: "",
      project_province: "",
      rapep_firm: "",
      application_status: "",
      submitted_from: "",
      submitted_to: "",
    })
  }

  return (
    <>
      <hr />
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label>Applicant</Label>
              <Input
                type="text"
                value={filterValues.applicant}
                onChange={e => setFilterValues({ ...filterValues, applicant: e.target.value })}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Title of Project</Label>
              <Input
                type="text"
                value={filterValues.title_of_project}
                onChange={e => setFilterValues({ ...filterValues, title_of_project: e.target.value })}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Province</Label>
              <Input
                type="text"
                value={filterValues.project_province}
                onChange={e => setFilterValues({ ...filterValues, project_province: e.target.value })}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Consulting Firm (RAPEP)</Label>
              <Input
                type="text"
                value={filterValues.rapep_firm}
                onChange={e => setFilterValues({ ...filterValues, rapep_firm: e.target.value })}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Application Status</Label>
              <Input
                type="select"
                value={filterValues.application_status}
                onChange={e => setFilterValues({ ...filterValues, application_status: e.target.value })}
              >
                <option value="">Select...</option>
                <option value="SUBMITTED">SUBMITTED</option>
                <option value="REJECTED">REJECTED</option>
                <option value="REPORT SUBMITTED">REPORT SUBMITTED</option>
                <option value="REPORT REVIEWED">REPORT REVIEWED</option>
                <option value="REPORT APPROVED">REPORT APPROVED</option>
                {/* <option value="DEPARTMENT REJECTED">DEPARTMENT REJECTED</option> */}
                {/* <option value="REPORT REJECTED">REPORT REJECTED</option> */}
                <option value="UNDER REVIEW">UNDER REVIEW</option>
                <option value="TOR_APPROVED">TOR APPROVED</option>
                <option value="REVIEWED">REVIEWED</option>
                <option value="DEPARTMENT APPROVED">DEPARTMENT APPROVED</option>
                {/* <option value="DG APPROVED">DG APPROVED</option> */}
              </Input>
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Date From</Label>
              <Input
                type="date"
                value={filterValues.submitted_from}
                onChange={e => setFilterValues({ ...filterValues, submitted_from: e.target.value })}
              />
            </FormGroup>
          </Col>

          <Col md={3}>
            <FormGroup>
              <Label>Date To</Label>
              <Input
                type="date"
                value={filterValues.submitted_to}
                onChange={e => setFilterValues({ ...filterValues, submitted_to: e.target.value })}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Button color="info" onClick={clearFields}>
              Reset
            </Button>
          </Col>
          <Col md={6}>
            <Button color="primary" type="submit">
              Search
            </Button>
          </Col>
        </Row>
      </Form>
      <hr />
    </>
  )
}


export default EnvAuditApplicationFilter
